import { makeHasEnded } from '@/competitions/_common/utils.ts';

import { JULY_2025_CAMPAIGN_END_DATE } from '../../../config.ts';

export const useHasEnded = makeHasEnded(JULY_2025_CAMPAIGN_END_DATE);
